<template>
  <div>
    <div class="layout">
      <el-tabs v-model="activeName" @tab-click="handleClick" v-if="type == 1">
        <el-tab-pane
          v-for="(i, j) in datalist"
          :key="j"
          :label="i.name"
          :name="i.name"
        ></el-tab-pane>
      </el-tabs>
      <div class="content" v-if="tablelist">
        <div
          class="contentsingle"
          v-for="(i, j) in tablelist"
          :key="j"
          :style="{
            background: `url(${i.url})`,
          }"
          @click="showimgs(i, j)"
        >
          <div class="singlehover"></div>
          <div class="singletitle">{{ i.title }}</div>
        </div>
      </div>
    </div>
    <el-dialog :title="showname" :visible.sync="showimg" width="57.29%">
      <div class="previewcon">
        <img style="width: 54.17vw; height: auto" :src="imgurl" alt="" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["datalist", "type", "navindex", "tablelist"],
  data() {
    return {
      activeName: "",
      showlist: [],
      showname: "",
      showimg: false,
      imgurl: "",
    };
  },
  methods: {
    showimgs(i, j) {
      this.showimg = true;
      this.imgurl = i.url;
      this.showname = i.title;
    },
    handleClick(e) {
      for (let i in this.datalist) {
        if (i == e.index) {
          this.$emit("changelast", this.datalist[i].name);
        }
      }
    },
  },
  mounted() {
    if (this.type == 1) {
      this.activeName = this.datalist[0].name;
    }
  },
  watch: {
    datalist(n, o) {
      this.activeName = this.datalist[0].name;
    },
  },
};
</script>

<style scoped lang="less">
.layout {
  .content {
    .contentsingle:hover .singlehover {
      background: linear-gradient(
        rgba(6, 25, 45, 0),
        rgba(25, 97, 172, 1)
      ) !important;
    }
    .contentsingle {
      .singletitle {
        position: absolute;
        z-index: 2;
        height: 1.46vw;
        left: 1.25vw;
        bottom: 1.25vw;
        font-size: 1.04vw;
        color: #ffffff;
      }
      .singlehover {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 8.44vw;
        z-index: 1;
        background: linear-gradient(rgba(6, 25, 45, 0), rgba(6, 25, 45, 0.6));
        /* display: none; */
      }
      width: 28.44vw;
      height: 16.93vw;
      position: relative;
      background-position: 0 0 !important;
      background-size: 100% 100% !important;
    }
    width: 100%;
    height: 100%;
    padding: 0.52vw 1.56vw 1.56vw 1.56vw;
    display: flex;
    gap: 1.25vw;
    flex-wrap: wrap;
    overflow-y: scroll;
    gap: 1.25vw;
  }
  .content::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  ::v-deep .el-tabs__nav-scroll {
    width: 100%;
    justify-content: left;
    padding-bottom: 0.52vw;
  }
  ::v-deep .el-tabs__active-bar {
    height: 0.16vw !important;
    border-radius: 0.21vw 0.21vw 0 0;
  }
  max-width: 100%;
  overflow: hidden;
  height: 44.79vw;
  padding: 0.83vw 0 4.17vw 0;
}
::v-deep .el-dialog__header {
  background: rgba(209, 223, 238, 0.7);
  text-align: center;
  padding: 1.04vw 0;
  height: 4.17vw;
  line-height: 2.08vw;
}
::v-deep .el-icon-close {
  font-size: 1.88vw !important;
  color: rgba(0, 0, 0, 0.6) !important;
  line-height: 1.88vw;
}
::v-deep .el-dialog__headerbtn {
  top: 1.15vw;
}
::v-deep .el-dialog__body {
  padding: 1.56vw;
}
.previewcon {
  width: 100%;
  background: rgba(247, 249, 252, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
